import { render, staticRenderFns } from "./Fronteras.vue?vue&type=template&id=c77cad74&scoped=true"
import script from "./Fronteras.vue?vue&type=script&lang=js"
export * from "./Fronteras.vue?vue&type=script&lang=js"
import style0 from "./Fronteras.vue?vue&type=style&index=0&id=c77cad74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77cad74",
  null
  
)

export default component.exports